export default "__VITE_ASSET__CZkj4OcG__"